import { render, staticRenderFns } from "./top-custom.vue?vue&type=template&id=4f63f060&scoped=true"
import script from "./top-custom.vue?vue&type=script&lang=js"
export * from "./top-custom.vue?vue&type=script&lang=js"
import style0 from "./top-custom.vue?vue&type=style&index=0&id=4f63f060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f63f060",
  null
  
)

export default component.exports